<template lang="pug">
div#serviceSelector
  //- el-select(v-model="currentServiceCate" :placeholder="$t('service.category_select')" :teleported="false")
    el-option.my-option(
      v-for="item in serviceOptions"
      :key="item.value"
      :label="$t(item.value)"
      :value="item.value")
  //- client-only
  Select.shadow-none.border-0(v-model="currentServiceCate")
    SelectTrigger.shadow-none.border-0.ring-0.text-base.p-1.text-primary.font-medium.bg-transparent(class="w-[250px] dark:bg-transparent md:p-1 md:text-lg")
      SelectValue(placeholder="Service")
    SelectContent.ring-0
      SelectGroup.ring-0.p-0
        SelectItem.font-medium(v-for="item in serviceOptions" :key="item.value" :value="item.value") {{ $t(item.value) }}

</template>

<script lang="ts" setup>
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
const userPref = useUserPref()
const service = useUserService()
const user = useUser()
const $t = useI18n().t

const serviceOptions = [
  { value: 'allplatform' },
  { value: 'home' },
] as { value: ServiceCate }[]

// const boughtServiceCate = computed(() => service.boughtServiceCate)

// const initServiceCate = () => {
//   // console.log('!!!!!!!!!!!! serviceArray changed, usableServiceCate:', usableServiceCategories.value)
//   if (!boughtServiceCate.value.includes(userPref.preferredServiceCate as ServiceCate)) {
//     // console.log('preferredServiceCate is not usable, set to first usable one')
//     userPref.setPreferredServiceCate(service.usableServiceCate[0]!)
//   }
// }

// watch(boughtServiceCate, initServiceCate)

const currentServiceCate = computed<ServiceCate>({
  // @ts-expect-error
  get(): ServiceCate | null {
    return service.currentServiceCate
  },
  set(value: ServiceCate) {
    console.log('currentServiceCate changed:', value)
    console.log('service[value] is:', service[value])
    if (service[value]) {
      service.currentServiceCate = value
      userPref.setPreferredServiceCate(value)
    } else {
      useDialog().confirm({
        title: $t(`services.${value}.name`),
        body: $t('not_bought'),
        confirmButtonText: $t('confirm'),
        cancelButtonText: $t('cancel'),
        defaultFocusButton: 'confirm',
      }).then(
        (ret) => {
          if (ret === 'confirm') {
            navigateTo(`/pricing?asUser=${user.id}&cate=${value}`)
          }
        },
        () => { }
      )
    }
  }
})
</script>

<style lang="postcss">
#serviceSelector {
  --el-font-size-base: 18px;
  max-width: 135px;
  margin-left: 10px;
  display: flex;
  vertical-align: middle;
  * {
    border: none;
  }

  @media (max-width: 768px) {
    max-width: 120px;
    margin-left: 0;
  }

  .my-option {
    span {
      font-size: 1.2rem;
    }
  }
}
</style>
